<div class="flex items-center justify-center h-[80vh]">
  <div class="flex flex-col items-center">
    <img src="assets/images/EscrowTabLogo.svg" class="w-auto h-32" />

    @if (!requestSent) {
      <p class="pt-6 text-4xl font-bold text-center text-midnight">
        Forgot your password?
      </p>
      <p class="pb-12 text-xl font-medium text-center text-midnight">
        Enter your email and we&apos;ll send you a link to reset it.
      </p>
      <form
        class="flex flex-col"
        [formGroup]="form"
        (ngSubmit)="requestReset(form.value.email)"
      >
        <et-atoms-input>
          <label class="!bg-base-100">Email</label>
          <input
            class="!bg-transparent !w-96"
            etAtomsInput
            formControlName="email"
            type="email"
            autocomplete="email"
          />
          @if (
            form.get('email')?.touched &&
            form.get('email')?.hasError('isOffline')
          ) {
            <span etAtomsInputError>Please, try again when online</span>
          }
        </et-atoms-input>
        <div class="flex justify-center mt-4">
          <button
            type="submit"
            [disabled]="form.invalid || submitted"
            class="self-center capitalize rounded-full w-44 btn btn-xl btn-primary"
          >
            Send reset link
          </button>
          @if (submitted) {
            <et-atoms-spinner
              class="absolute mt-1 text-center ml-[250px]"
            ></et-atoms-spinner>
          }
        </div>
      </form>
      <a
        routerLink="/auth/login"
        class="mt-6 underline normal-case btn btn-link text-midnight"
        >Back to login</a
      >
    } @else {
      <p class="pt-6 text-2xl font-medium text-center text-midnight">
        If that email exists, we&apos;ve sent a password reset link.
      </p>
      <a
        routerLink="/auth/login"
        class="mt-6 underline normal-case btn btn-link text-midnight"
        >Back to login</a
      >
    }
  </div>
</div>
